export class ZbdGlobals {
    embedded = false;
}

export var zbdGlobals: ZbdGlobals = new ZbdGlobals();
